<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>Admin Page</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-card>
        <ion-card-header>
          <h1 style="color: #03346e; font-weight: bold">Menu</h1>
        </ion-card-header>
        <ion-grid>
          <ion-row>
            <ion-col size="6">
              <div
                class="menu-item"
                @click.prevent="toNavigate('halamankelas')"
                style="
                  background-color: #03346e;
                  border-radius: 8px;
                  padding: 10px;
                "
              >
                <ion-icon
                  :icon="addCircleOutline"
                  size="large"
                  style="color: #fff"
                ></ion-icon>
                <p style="color: #fff">Tambah Kelas</p>
              </div>
            </ion-col>
            <ion-col size="6">
              <div
                class="menu-item"
                @click.prevent="toNavigate('halamanmatapelajaran')"
                style="
                  background-color: #03346e;
                  border-radius: 8px;
                  padding: 10px;
                "
              >
                <ion-icon
                  :icon="addCircleOutline"
                  size="large"
                  style="color: #fff"
                ></ion-icon>
                <p style="color: #fff">Tambah Mata Pelajaran</p>
              </div>
            </ion-col>
            <ion-col size="6">
              <div
                class="menu-item"
                @click.prevent="toNavigate('laporankehadiranAdmin')"
                style="
                  background-color: #03346e;
                  border-radius: 8px;
                  padding: 10px;
                "
              >
                <ion-icon
                  :icon="informationCircleOutline"
                  size="large"
                  style="color: #fff"
                ></ion-icon>
                <p style="color: #fff">Laporan Kehadiaran</p>
              </div>
            </ion-col>
            <ion-col size="6">
              <div
                class="menu-item"
                @click.prevent="toNavigate('laporanizinAdmin')"
                style="
                  background-color: #03346e;
                  border-radius: 8px;
                  padding: 10px;
                "
              >
                <ion-icon
                  :icon="clipboardOutline"
                  size="large"
                  style="color: #fff"
                ></ion-icon>
                <p style="color: #fff">Lap Izin</p>
              </div>
            </ion-col>
            <ion-col size="6">
              <div
                class="menu-item"
                @click.prevent="toNavigate('halamanpenggunaAdmin')"
                style="
                  background-color: #03346e;
                  border-radius: 8px;
                  padding: 10px;
                "
              >
                <ion-icon
                  :icon="peopleOutline"
                  size="large"
                  style="color: #fff"
                ></ion-icon>
                <p style="color: #fff">Pengguna</p>
              </div>
            </ion-col>
            <ion-col size="6">
              <div
                class="menu-item"
                @click.prevent="toNavigate('halamansettingAdmin')"
                style="
                  background-color: #03346e;
                  border-radius: 8px;
                  padding: 10px;
                "
              >
                <ion-icon
                  :icon="settingsOutline"
                  size="large"
                  style="color: #fff"
                ></ion-icon>
                <p style="color: #fff">Setting</p>
              </div>
            </ion-col>
            <ion-col size="6">
              <div
                class="menu-item"
                @click.prevent="toNavigate('halamanshortsAdmin')"
                style="
                  background-color: #03346e;
                  border-radius: 8px;
                  padding: 10px;
                "
              >
                <ion-icon
                  :icon="videocamOutline"
                  size="large"
                  style="color: #fff"
                ></ion-icon>
                <p style="color: #fff">Manajemen Shorts</p>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card>

      <ion-card>
        <h1 style="color: #03346e; font-weight: bold">Data Pengguna</h1>
        <ion-grid class="table">
          <ion-row class="table-header">
            <ion-col>Nama Lengkap</ion-col>
            <ion-col>Username</ion-col>
            <ion-col>Email</ion-col>
            <ion-col>Status</ion-col>
            <ion-col>Aksi</ion-col>
          </ion-row>
          <ion-row
            v-for="user in paginatedUsers"
            :key="user.id"
            class="table-row"
          >
            <ion-col>{{ user.fullName }}</ion-col>
            <ion-col>{{ user.username }}</ion-col>
            <ion-col>{{ user.email }}</ion-col>
            <ion-col>{{ user.status }}</ion-col>
            <ion-col>
              <ion-badge
                @click="updateStatus(user)"
                :color="user.status === 'non-aktif' ? 'success' : 'warning'"
                style="cursor: pointer"
              >
                {{ user.status === "non-aktif" ? "Aktifkan" : "Non-aktifkan" }}
              </ion-badge>
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-button @click="loadMoreUsers" v-if="showMoreUsers" color="primary"
          >Load More Users</ion-button
        >
        <ion-button @click="exportUsersToExcel" color="success"
          >Export Data Pengguna ke Excel</ion-button
        >
      </ion-card>

      <ion-card>
        <h1 style="color: #03346e; font-weight: bold">Input Titik Koordinat</h1>
        <ion-item>
          <ion-label position="floating">Latitude</ion-label>
          <ion-input
            v-model="latitude"
            type="number"
            :readonly="!isEditing"
          ></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="floating">Longitude</ion-label>
          <ion-input
            v-model="longitude"
            type="number"
            :readonly="!isEditing"
          ></ion-input>
        </ion-item>
        <ion-badge
          @click="isEditing ? saveCoordinates() : enableEditing()"
          color="success"
          style="cursor: pointer"
        >
          {{ isEditing ? "Simpan Koordinat" : "Edit Koordinat" }}
        </ion-badge>
      </ion-card>
      <ion-card>
        <h1 style="color: #03346e; font-weight: bold">Laporan Absensi</h1>
        <ion-grid class="table">
          <ion-row class="table-header">
            <ion-col>Nama Lengkap</ion-col>
            <ion-col>Tanggal</ion-col>
            <ion-col>Masuk</ion-col>
            <ion-col>Keluar</ion-col>
            <ion-col>Keterangan Telat</ion-col>
          </ion-row>
          <ion-row
            v-for="record in paginatedAttendanceRecords"
            :key="record.id"
            class="table-row"
          >
            <ion-col>{{ record.fullName }}</ion-col>
            <ion-col>{{ record.date }}</ion-col>
            <ion-col>
              <ion-badge :color="isLate(record.masuk) ? 'danger' : 'success'">
                {{ record.masuk ? record.masuk : "Belum absen" }}
              </ion-badge>
            </ion-col>
            <ion-col>
              {{ record.keluar ? record.keluar : "Belum absen" }}
            </ion-col>
            <ion-col>
              {{ getLateTime(record.masuk) }}
            </ion-col>
          </ion-row>
        </ion-grid>
        <ion-button
          @click="loadMoreAttendanceRecords"
          v-if="showMoreAttendanceRecords"
          color="primary"
          >Load More Attendance Records</ion-button
        >
        <ion-button @click="exportAttendanceToExcel" color="success"
          >Export Laporan Absensi ke Excel</ion-button
        >

        <ion-toast
          :is-open="toast.isOpen"
          :message="toast.message"
          :duration="toast.duration"
          :color="toast.color"
          @did-dismiss="toast.isOpen = false"
        ></ion-toast>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script setup>
import {
  informationCircleOutline,
  clipboardOutline,
  peopleOutline,
  settingsOutline,
  addCircleOutline,
  videocamOutline,
} from "ionicons/icons";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  updateDoc,
  setDoc,
  getDoc,
  query,
  orderBy,
} from "firebase/firestore";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonBadge,
  IonItem,
  IonLabel,
  IonInput,
  IonButton,
  IonToast,
} from "@ionic/vue";
import { firebaseApp } from "../views/firebase.js";
import * as XLSX from "xlsx";

const db = getFirestore(firebaseApp);
const users = ref([]);
const attendanceRecords = ref([]);
const latitude = ref("");
const longitude = ref("");
const isEditing = ref(false);

const router = useRouter();
const toNavigate = (routeName) => {
  router.push({ name: routeName });
};

const toast = ref({
  isOpen: false,
  message: "",
  duration: 2000,
  color: "success",
});

const usersPage = ref(1);
const usersPerPage = 10;
const attendancePage = ref(1);
const attendancePerPage = 10;

const fetchUsers = async () => {
  try {
    const querySnapshot = await getDocs(collection(db, "users"));
    users.value = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
    console.log("Users fetched:", users.value);
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};

const paginatedUsers = computed(() => {
  return users.value.slice(0, usersPage.value * usersPerPage);
});

const showMoreUsers = computed(() => {
  return usersPage.value * usersPerPage < users.value.length;
});

const loadMoreUsers = () => {
  usersPage.value++;
};

const fetchCoordinates = async () => {
  try {
    const docSnapshot = await getDoc(doc(db, "settings", "coordinates"));
    if (docSnapshot.exists()) {
      const data = docSnapshot.data();
      latitude.value = data.latitude;
      longitude.value = data.longitude;
      console.log("Coordinates fetched:", data);
    }
  } catch (error) {
    console.error("Error fetching coordinates:", error);
  }
};

const fetchAttendanceRecords = async () => {
  try {
    const usersSnapshot = await getDocs(collection(db, "users"));
    const usersList = usersSnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    let records = [];
    for (const user of usersList) {
      const recordsRef = collection(db, "attendance", user.id, "records");
      const recordsSnapshot = await getDocs(
        query(recordsRef, orderBy("masuk", "desc"))
      );

      records = records.concat(
        recordsSnapshot.docs.map((doc) => {
          const data = doc.data();
          return {
            id: doc.id,
            userId: user.id,
            fullName: user.fullName,
            date: doc.id,
            masuk: data.masuk
              ? data.masuk.toDate().toLocaleString()
              : "Belum absen",
            keluar: data.keluar
              ? data.keluar.toDate().toLocaleString()
              : "Belum absen",
            lateTime: getLateTime(data.masuk ? data.masuk.toDate() : null),
          };
        })
      );
    }

    attendanceRecords.value = records;
    console.log("Attendance records fetched:", attendanceRecords.value);
  } catch (error) {
    console.error("Error fetching attendance records:", error);
  }
};

const paginatedAttendanceRecords = computed(() => {
  return attendanceRecords.value.slice(
    0,
    attendancePage.value * attendancePerPage
  );
});

const showMoreAttendanceRecords = computed(() => {
  return (
    attendancePage.value * attendancePerPage < attendanceRecords.value.length
  );
});

const loadMoreAttendanceRecords = () => {
  attendancePage.value++;
};

const updateStatus = async (user) => {
  try {
    const userRef = doc(db, "users", user.id);
    const newStatus = user.status === "non-aktif" ? "aktif" : "non-aktif";
    await updateDoc(userRef, { status: newStatus });
    user.status = newStatus; // Update status locally for immediate UI feedback
    showToast("Status pengguna berhasil diubah.", "success");
  } catch (error) {
    console.error("Error updating user status:", error);
    showToast("Terjadi kesalahan saat mengubah status pengguna.", "danger");
  }
};

const saveCoordinates = async () => {
  try {
    await setDoc(doc(db, "settings", "coordinates"), {
      latitude: parseFloat(latitude.value),
      longitude: parseFloat(longitude.value),
    });
    console.log("Coordinates saved");
    isEditing.value = false;
    showToast("Koordinat berhasil disimpan.", "success");
  } catch (error) {
    console.error("Error saving coordinates:", error);
    showToast("Terjadi kesalahan saat menyimpan koordinat.", "danger");
  }
};

const enableEditing = () => {
  isEditing.value = true;
};

const isLate = (timestamp) => {
  if (!timestamp) return false;
  const time = new Date(timestamp);
  const eightAM = new Date(time);
  eightAM.setHours(8, 0, 0, 0); // 8 AM
  return time > eightAM;
};

const getLateTime = (timestamp) => {
  if (!timestamp) return "";
  const time = new Date(timestamp);
  const eightAM = new Date(time);
  eightAM.setHours(8, 0, 0, 0); // 8 AM
  if (time > eightAM) {
    const diff = Math.floor((time - eightAM) / 60000); // difference in minutes
    const hours = Math.floor(diff / 60);
    const minutes = diff % 60;
    return `${hours} jam ${minutes} menit`;
  }
  return "Tepat Waktu";
};

const exportUsersToExcel = () => {
  const worksheet = XLSX.utils.json_to_sheet(users.value);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Data Pengguna");
  XLSX.writeFile(workbook, "data_pengguna.xlsx");
};

const exportAttendanceToExcel = () => {
  const worksheet = XLSX.utils.json_to_sheet(attendanceRecords.value);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Laporan Absensi");
  XLSX.writeFile(workbook, "laporan_absensi.xlsx");
};

const showToast = (message, color) => {
  toast.value = {
    isOpen: true,
    message,
    duration: 2000,
    color,
  };
};

onMounted(() => {
  fetchUsers();
  fetchCoordinates();
  fetchAttendanceRecords();
});
</script>

<style>
.table {
  border-collapse: collapse;
  width: 100%;
}

.table-header {
  background-color: #f2f2f2;
  font-weight: bold;
}

.table-row {
  border-bottom: 1px solid #ddd;
}

.table-row ion-col {
  border: 1px solid #ddd;
  padding: 8px;
}

.table-row:hover {
  background-color: #f1f1f1;
}

.table-row ion-badge {
  margin-top: 4px;
}
</style>
